import React from 'react'
import { Button } from '../../common'
import { useEffect, useState } from 'react'
interface Props {
  showModal: boolean
  closeModal: () => void
  title?: string
  description?: string
}

export function ModalErrorMicrophone({ showModal, closeModal, title, description }: Props) {
  const [colorStatus, setColorStatus ] = useState('')
  const [bgStatus, setBgStatus] = useState('')
  const [titleStatus, setTitleStatus] = useState(title)
  const [descriptionStatus, setDescriptionStatus] = useState(description)

  return (
    <>
      {showModal ? (
        <>
          <div className="modal-form-journey justify-center items-center flex overflow-x-hidden fixed inset-0 z-[100000] outline-none focus:outline-none rounded-lg m-auto">
            <div className="relative w-auto mx-auto  max-w-full">
              <div className="container-modal rounded-lg shadow-xl relative bg-white mt-20 outline-none focus:outline-none md:w-[553px] max-w-full mx-5 py-4 max-h-screen">
                <div className="modal-body px-4 lg:px-10 text-center">
                  <h2 className="text-2xl text-black font-bold ">{titleStatus}</h2>
                  <p className='text-lg mt-4'>
                    {descriptionStatus}
                  </p>
                <Button variant='orange' className='mt-5 m-auto w-full' disabled={status == 'loading'} onClick={closeModal}>OK, OBRIGADO!</Button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-[2] bg-black"></div>
        </>
      ) : null}
    </>
  )
}
